<template>
    <div class="error-text mb-3">{{ errorMessage }}</div>
</template>

<script>
import { mapGetters } from 'vuex';

/**
 * ServerError
 *
 * We need to handle mixed cases of inconsistent response objects.
 * Some reponses will not have a status and map of messages
 */
export default {
    props: {
        error: Error
    },
    computed: {
        ...mapGetters({
            commonStrings: 'commonStrings',
            txce: 'translationsError'
        }),
        errorMessage() {
            // no response, fallback on message. this is typically a 'Network Error'
            if (!this.error.response) {
                if (this.error.message) {
                    switch (this.error.message) {
                        case 'Network Error':
                            return this.commonStrings.networkError;
                        case 'Undefined Error':
                            return this.txce.unableToSave;
                        default:
                            return this.error.message;
                    }
                } else {
                    return this.txce.systemFailure;
                }
            }

            switch (this.error.response.data.status) {
                case 400:
                    switch (this.error.response.data.messages[0].technicalMessage) {
                        case 'Invalid Credentials':
                        case 'Old Password is not correct':
                            return this.txce.passwordUpdationFailed;
                        case 'Password cannot be your current password':
                            return this.commonStrings.newPasswordNotCurrent;
                        default:
                            return this.error.response.data.messages[0].technicalMessage
                                ? this.error.response.data.messages[0].technicalMessage
                                : this.txce.nonSpecific;
                    }
                case 408:
                    return this.txce.timeout;
                case 500:
                    return this.txce.systemFailure;
                default:
                    // all other responses
                    return this.error.response.data.messages[0].technicalMessage
                        ? this.error.response.data.messages[0].technicalMessage
                        : this.txce.systemFailure;
            }
        }
    }
};
</script>

<style lang="scss">
</style>